/**
 * Janela bancária do pagamento de boleto (dias úteis, das 06:00 às 22:00 BRT).
 * Quem decide é o servidor — a tela só lê o `paymentWindow` da consulta para
 * travar o botão de pagar e mostrar o aviso.
 */
export interface BilletPaymentWindow {
  withinWindow: boolean;
  nextBusinessDay?: string | null;
  blockMessage?: string | null;
}

const DEFAULT_BLOCK_MESSAGE =
  'Pagamentos de boleto são processados apenas em dias úteis, das 06:00 às 22:00. ' +
  'Faça o pagamento no próximo dia útil.';

export function billetPaymentWindowBlock(paymentWindow?: BilletPaymentWindow | null): {
  blocked: boolean;
  message: string;
} {
  if (!paymentWindow || paymentWindow.withinWindow) {
    return { blocked: false, message: '' };
  }

  // Fallback caso o front esteja mais novo que o servidor.
  return { blocked: true, message: paymentWindow.blockMessage || DEFAULT_BLOCK_MESSAGE };
}
